<template>
  <div>
      <div id="browserInfo" v-if="invalidBrowser">
           <p>
               Para una mejor experiencia, utiliza <a href="https://www.google.com.co/chrome/" target="_blank">Google Chrome</a>
               o <a href="https://www.mozilla.org/es-ES/firefox/new/" target="_blank">Mozilla Firefox</a>.
           </p>
       </div>
      <router-view/>
  </div>
</template>

<script>
export default {
    data() {
        return {
            invalidBrowser: true
        }
    },
    mounted() {
        const browser = this.$browserDetect.meta.name;
        this.invalidBrowser = (browser === 'IE' || browser === 'Edge');
        // this.invalidBrowser = (browser === 'IE' || browser === 'Chrome');
    }
}
</script>
<style >

    .autocomplete-input {
        height: 35px;
    }

    #browserInfo {
        color: #ffffff;
        text-align: center;
        position: absolute;
        width: 100%;
        height: 25px;
        background: #075c98;
        top: 0;
        left: 0;
        z-index: 3;
    }

    #browserInfo a {
        color: #ffffff;
        text-decoration: underline;
    }
</style>